function createModal() {
  const countries = [ 
      {name: 'Afghanistan', code: 'AF'}, 
      {name: 'Åland Islands', code: 'AX'}, 
      {name: 'Albania', code: 'AL'}, 
      {name: 'Algeria', code: 'DZ'}, 
      {name: 'American Samoa', code: 'AS'}, 
      {name: 'AndorrA', code: 'AD'}, 
      {name: 'Angola', code: 'AO'}, 
      {name: 'Anguilla', code: 'AI'}, 
      {name: 'Antarctica', code: 'AQ'}, 
      {name: 'Antigua and Barbuda', code: 'AG'}, 
      {name: 'Argentina', code: 'AR'}, 
      {name: 'Armenia', code: 'AM'}, 
      {name: 'Aruba', code: 'AW'}, 
      {name: 'Australia', code: 'AU'}, 
      {name: 'Austria', code: 'AT'}, 
      {name: 'Azerbaijan', code: 'AZ'}, 
      {name: 'Bahamas', code: 'BS'}, 
      {name: 'Bahrain', code: 'BH'}, 
      {name: 'Bangladesh', code: 'BD'}, 
      {name: 'Barbados', code: 'BB'}, 
      {name: 'Belarus', code: 'BY'}, 
      {name: 'Belgium', code: 'BE'}, 
      {name: 'Belize', code: 'BZ'}, 
      {name: 'Benin', code: 'BJ'}, 
      {name: 'Bermuda', code: 'BM'}, 
      {name: 'Bhutan', code: 'BT'}, 
      {name: 'Bolivia', code: 'BO'}, 
      {name: 'Bosnia and Herzegovina', code: 'BA'}, 
      {name: 'Botswana', code: 'BW'}, 
      {name: 'Bouvet Island', code: 'BV'}, 
      {name: 'Brazil', code: 'BR'}, 
      {name: 'British Indian Ocean Territory', code: 'IO'}, 
      {name: 'Brunei Darussalam', code: 'BN'}, 
      {name: 'Bulgaria', code: 'BG'}, 
      {name: 'Burkina Faso', code: 'BF'}, 
      {name: 'Burundi', code: 'BI'}, 
      {name: 'Cambodia', code: 'KH'}, 
      {name: 'Cameroon', code: 'CM'}, 
      {name: 'Canada', code: 'CA'}, 
      {name: 'Cape Verde', code: 'CV'}, 
      {name: 'Cayman Islands', code: 'KY'}, 
      {name: 'Central African Republic', code: 'CF'}, 
      {name: 'Chad', code: 'TD'}, 
      {name: 'Chile', code: 'CL'}, 
      {name: 'China', code: 'CN'}, 
      {name: 'Christmas Island', code: 'CX'}, 
      {name: 'Cocos (Keeling) Islands', code: 'CC'}, 
      {name: 'Colombia', code: 'CO'}, 
      {name: 'Comoros', code: 'KM'}, 
      {name: 'Congo', code: 'CG'}, 
      {name: 'Congo, The Democratic Republic of the', code: 'CD'}, 
      {name: 'Cook Islands', code: 'CK'}, 
      {name: 'Costa Rica', code: 'CR'}, 
      {name: 'Cote D\'Ivoire', code: 'CI'}, 
      {name: 'Croatia', code: 'HR'}, 
      {name: 'Cuba', code: 'CU'}, 
      {name: 'Cyprus', code: 'CY'}, 
      {name: 'Czech Republic', code: 'CZ'}, 
      {name: 'Denmark', code: 'DK'}, 
      {name: 'Djibouti', code: 'DJ'}, 
      {name: 'Dominica', code: 'DM'}, 
      {name: 'Dominican Republic', code: 'DO'}, 
      {name: 'Ecuador', code: 'EC'}, 
      {name: 'Egypt', code: 'EG'}, 
      {name: 'El Salvador', code: 'SV'}, 
      {name: 'Equatorial Guinea', code: 'GQ'}, 
      {name: 'Eritrea', code: 'ER'}, 
      {name: 'Estonia', code: 'EE'}, 
      {name: 'Ethiopia', code: 'ET'}, 
      {name: 'Falkland Islands (Malvinas)', code: 'FK'}, 
      {name: 'Faroe Islands', code: 'FO'}, 
      {name: 'Fiji', code: 'FJ'}, 
      {name: 'Finland', code: 'FI'}, 
      {name: 'France', code: 'FR'}, 
      {name: 'French Guiana', code: 'GF'}, 
      {name: 'French Polynesia', code: 'PF'}, 
      {name: 'French Southern Territories', code: 'TF'}, 
      {name: 'Gabon', code: 'GA'}, 
      {name: 'Gambia', code: 'GM'}, 
      {name: 'Georgia', code: 'GE'}, 
      {name: 'Germany', code: 'DE'}, 
      {name: 'Ghana', code: 'GH'}, 
      {name: 'Gibraltar', code: 'GI'}, 
      {name: 'Greece', code: 'GR'}, 
      {name: 'Greenland', code: 'GL'}, 
      {name: 'Grenada', code: 'GD'}, 
      {name: 'Guadeloupe', code: 'GP'}, 
      {name: 'Guam', code: 'GU'}, 
      {name: 'Guatemala', code: 'GT'}, 
      {name: 'Guernsey', code: 'GG'}, 
      {name: 'Guinea', code: 'GN'}, 
      {name: 'Guinea-Bissau', code: 'GW'}, 
      {name: 'Guyana', code: 'GY'}, 
      {name: 'Haiti', code: 'HT'}, 
      {name: 'Heard Island and Mcdonald Islands', code: 'HM'}, 
      {name: 'Holy See (Vatican City State)', code: 'VA'}, 
      {name: 'Honduras', code: 'HN'}, 
      {name: 'Hong Kong', code: 'HK'}, 
      {name: 'Hungary', code: 'HU'}, 
      {name: 'Iceland', code: 'IS'}, 
      {name: 'India', code: 'IN'}, 
      {name: 'Indonesia', code: 'ID'}, 
      {name: 'Iran, Islamic Republic Of', code: 'IR'}, 
      {name: 'Iraq', code: 'IQ'}, 
      {name: 'Ireland', code: 'IE'}, 
      {name: 'Isle of Man', code: 'IM'}, 
      {name: 'Israel', code: 'IL'}, 
      {name: 'Italy', code: 'IT'}, 
      {name: 'Jamaica', code: 'JM'}, 
      {name: 'Japan', code: 'JP'}, 
      {name: 'Jersey', code: 'JE'}, 
      {name: 'Jordan', code: 'JO'}, 
      {name: 'Kazakhstan', code: 'KZ'}, 
      {name: 'Kenya', code: 'KE'}, 
      {name: 'Kiribati', code: 'KI'}, 
      {name: 'Korea, Democratic People\'S Republic of', code: 'KP'}, 
      {name: 'Korea, Republic of', code: 'KR'}, 
      {name: 'Kuwait', code: 'KW'}, 
      {name: 'Kyrgyzstan', code: 'KG'}, 
      {name: 'Lao People\'S Democratic Republic', code: 'LA'}, 
      {name: 'Latvia', code: 'LV'}, 
      {name: 'Lebanon', code: 'LB'}, 
      {name: 'Lesotho', code: 'LS'}, 
      {name: 'Liberia', code: 'LR'}, 
      {name: 'Libyan Arab Jamahiriya', code: 'LY'}, 
      {name: 'Liechtenstein', code: 'LI'}, 
      {name: 'Lithuania', code: 'LT'}, 
      {name: 'Luxembourg', code: 'LU'}, 
      {name: 'Macao', code: 'MO'}, 
      {name: 'Macedonia, The Former Yugoslav Republic of', code: 'MK'}, 
      {name: 'Madagascar', code: 'MG'}, 
      {name: 'Malawi', code: 'MW'}, 
      {name: 'Malaysia', code: 'MY'}, 
      {name: 'Maldives', code: 'MV'}, 
      {name: 'Mali', code: 'ML'}, 
      {name: 'Malta', code: 'MT'}, 
      {name: 'Marshall Islands', code: 'MH'}, 
      {name: 'Martinique', code: 'MQ'}, 
      {name: 'Mauritania', code: 'MR'}, 
      {name: 'Mauritius', code: 'MU'}, 
      {name: 'Mayotte', code: 'YT'}, 
      {name: 'Mexico', code: 'MX'}, 
      {name: 'Micronesia, Federated States of', code: 'FM'}, 
      {name: 'Moldova, Republic of', code: 'MD'}, 
      {name: 'Monaco', code: 'MC'}, 
      {name: 'Mongolia', code: 'MN'}, 
      {name: 'Montserrat', code: 'MS'}, 
      {name: 'Morocco', code: 'MA'}, 
      {name: 'Mozambique', code: 'MZ'}, 
      {name: 'Myanmar', code: 'MM'}, 
      {name: 'Namibia', code: 'NA'}, 
      {name: 'Nauru', code: 'NR'}, 
      {name: 'Nepal', code: 'NP'}, 
      {name: 'Netherlands', code: 'NL'}, 
      {name: 'Netherlands Antilles', code: 'AN'}, 
      {name: 'New Caledonia', code: 'NC'}, 
      {name: 'New Zealand', code: 'NZ'}, 
      {name: 'Nicaragua', code: 'NI'}, 
      {name: 'Niger', code: 'NE'}, 
      {name: 'Nigeria', code: 'NG'}, 
      {name: 'Niue', code: 'NU'}, 
      {name: 'Norfolk Island', code: 'NF'}, 
      {name: 'Northern Mariana Islands', code: 'MP'}, 
      {name: 'Norway', code: 'NO'}, 
      {name: 'Oman', code: 'OM'}, 
      {name: 'Pakistan', code: 'PK'}, 
      {name: 'Palau', code: 'PW'}, 
      {name: 'Palestinian Territory, Occupied', code: 'PS'}, 
      {name: 'Panama', code: 'PA'}, 
      {name: 'Papua New Guinea', code: 'PG'}, 
      {name: 'Paraguay', code: 'PY'}, 
      {name: 'Peru', code: 'PE'}, 
      {name: 'Philippines', code: 'PH'}, 
      {name: 'Pitcairn', code: 'PN'}, 
      {name: 'Poland', code: 'PL'}, 
      {name: 'Portugal', code: 'PT'}, 
      {name: 'Puerto Rico', code: 'PR'}, 
      {name: 'Qatar', code: 'QA'}, 
      {name: 'Reunion', code: 'RE'}, 
      {name: 'Romania', code: 'RO'}, 
      {name: 'Russian Federation', code: 'RU'}, 
      {name: 'RWANDA', code: 'RW'}, 
      {name: 'Saint Helena', code: 'SH'}, 
      {name: 'Saint Kitts and Nevis', code: 'KN'}, 
      {name: 'Saint Lucia', code: 'LC'}, 
      {name: 'Saint Pierre and Miquelon', code: 'PM'}, 
      {name: 'Saint Vincent and the Grenadines', code: 'VC'}, 
      {name: 'Samoa', code: 'WS'}, 
      {name: 'San Marino', code: 'SM'}, 
      {name: 'Sao Tome and Principe', code: 'ST'}, 
      {name: 'Saudi Arabia', code: 'SA'}, 
      {name: 'Senegal', code: 'SN'}, 
      {name: 'Serbia and Montenegro', code: 'CS'}, 
      {name: 'Seychelles', code: 'SC'}, 
      {name: 'Sierra Leone', code: 'SL'}, 
      {name: 'Singapore', code: 'SG'}, 
      {name: 'Slovakia', code: 'SK'}, 
      {name: 'Slovenia', code: 'SI'}, 
      {name: 'Solomon Islands', code: 'SB'}, 
      {name: 'Somalia', code: 'SO'}, 
      {name: 'South Africa', code: 'ZA'}, 
      {name: 'South Georgia and the South Sandwich Islands', code: 'GS'}, 
      {name: 'Spain', code: 'ES'}, 
      {name: 'Sri Lanka', code: 'LK'}, 
      {name: 'Sudan', code: 'SD'}, 
      {name: 'Suriname', code: 'SR'}, 
      {name: 'Svalbard and Jan Mayen', code: 'SJ'}, 
      {name: 'Swaziland', code: 'SZ'}, 
      {name: 'Sweden', code: 'SE'}, 
      {name: 'Switzerland', code: 'CH'}, 
      {name: 'Syrian Arab Republic', code: 'SY'}, 
      {name: 'Taiwan, Province of China', code: 'TW'}, 
      {name: 'Tajikistan', code: 'TJ'}, 
      {name: 'Tanzania, United Republic of', code: 'TZ'}, 
      {name: 'Thailand', code: 'TH'}, 
      {name: 'Timor-Leste', code: 'TL'}, 
      {name: 'Togo', code: 'TG'}, 
      {name: 'Tokelau', code: 'TK'}, 
      {name: 'Tonga', code: 'TO'}, 
      {name: 'Trinidad and Tobago', code: 'TT'}, 
      {name: 'Tunisia', code: 'TN'}, 
      {name: 'Turkey', code: 'TR'}, 
      {name: 'Turkmenistan', code: 'TM'}, 
      {name: 'Turks and Caicos Islands', code: 'TC'}, 
      {name: 'Tuvalu', code: 'TV'}, 
      {name: 'Uganda', code: 'UG'}, 
      {name: 'Ukraine', code: 'UA'}, 
      {name: 'United Arab Emirates', code: 'AE'}, 
      {name: 'United Kingdom', code: 'GB'}, 
      {name: 'United States', code: 'US'}, 
      {name: 'United States Minor Outlying Islands', code: 'UM'}, 
      {name: 'Uruguay', code: 'UY'}, 
      {name: 'Uzbekistan', code: 'UZ'}, 
      {name: 'Vanuatu', code: 'VU'}, 
      {name: 'Venezuela', code: 'VE'}, 
      {name: 'Viet Nam', code: 'VN'}, 
      {name: 'Virgin Islands, British', code: 'VG'}, 
      {name: 'Virgin Islands, U.S.', code: 'VI'}, 
      {name: 'Wallis and Futuna', code: 'WF'}, 
      {name: 'Western Sahara', code: 'EH'}, 
      {name: 'Yemen', code: 'YE'}, 
      {name: 'Zambia', code: 'ZM'}, 
      {name: 'Zimbabwe', code: 'ZW'} 
    ];

  const countryOptions = countries.map(country => 
      `<option value="${country.code}">${country.name}</option>`
  ).join('');

  const modalHTML = `
  <div id="modalFormContainer" class="modal-form-container" style="display:none;">
      <div id="modalOverlay" style="position:fixed; top:0; left:0; width:100%; height:100%; background:rgba(0, 0, 0, 0.5); z-index:1000;"></div>
      <div id="modalContent" style="position:fixed; top:50%; left:50%; transform:translate(-50%, -50%); background:white; padding:20px; border-radius:8px; box-shadow:0 0 10px rgba(0, 0, 0, 0.5); z-index:1001;">
          <span id="closeModal" style="cursor:pointer; float:right; font-weight:bold;">&times;</span>
      <h2 style="font-size: 24px; color: #333; font-weight: bold; text-align: center; margin-bottom: 20px; border-bottom: 2px solid #eee; padding-bottom: 10px;">بيانات فاتورة الدفع</h2>
          <form id="customerInfoForm" action="#" method="POST" novalidate>
              <div class="form-row">
                  <div class="form-group">
                      <label for="firstName">الاسم الأول <span style="color:red;">*</span></label>
                      <input id="firstName" name="firstName" type="text" placeholder="الاسم الأول" required>
                      <span class="error-message">الرجاء إدخال الاسم الأول.</span>
                  </div>
                  <div class="form-group">
                      <label for="lastName">الاسم الأخير <span style="color:red;">*</span></label>
                      <input id="lastName" name="lastName" type="text" placeholder="الاسم الأخير" required>
                      <span class="error-message">الرجاء إدخال الاسم الأخير.</span>
                  </div>
              </div>

              <label for="email">البريد الإلكتروني <span style="color:red;">*</span></label>
              <input id="email" name="email" type="email" placeholder="البريد الإلكتروني" required>
              <span class="error-message">الرجاء إدخال بريد إلكتروني صالح.</span>
              
              <div class="form-row">
                  <div class="form-group">
                      <label for="country">الدولة <span style="color:red;">*</span></label>
                      <select id="country" name="country" required>
                          <option value="" disabled selected>اختر دولتك</option>
                          ${countryOptions}
                      </select>
                      <span class="error-message">الرجاء اختيار الدولة.</span>
                  </div>
              </div>
              
              <label for="phone">رقم الهاتف <span style="color:red;">*</span></label>
              <input id="phone" name="phone" type="tel" placeholder="555-555-5555" required>
              <span class="error-message">الرجاء إدخال رقم هاتف صالح.</span>
              
              <div class="button-container">
                  <button type="submit">إتمام الدفع</button>
              </div>
          </form>
          <div id="loadingOverlay" style="display:none; position:fixed; top:0; left:0; width:100%; height:100%; background: rgba(0, 0, 0, 0.7); z-index: 1002; text-align: center; padding-top: 20%;">
              <div class="spinner"></div>
              <p style="color: white;">جاري التحميل... يرجى الانتظار.</p>
          </div>
      </div>
  </div>
  `;

  // Append modal HTML to body
  document.body.insertAdjacentHTML('beforeend', modalHTML);

  const modalContainer = document.getElementById("modalFormContainer");
  const closeModalBtn = document.getElementById("closeModal");

  document.querySelectorAll('#openModal').forEach(button => {
      button.onclick = async function(event) {
          event.preventDefault();

          await fetch('/cart.js')
                .then(response => response.json())
                .then(cartData => {
                  console.log(cartData)
                // Parse the cart data from the button
                // const cartDataStr = this.getAttribute('data-cart');
                // const cartData = JSON.parse(cartDataStr);

                // Extract necessary values
                const total = cartData.total_price / 100; // price in SAR
                const currency = cartData.currency; // currency from cart
                const items = cartData.items || []; // line items for order creation


                // Check if items is an array
                if (!Array.isArray(items)) {
                    throw new Error("Items is not an array. Check cart data.");
                }

                // Prepare the line items for the order creation
                const lineItems = items.map(item => ({
                    title: item.product_title || item.title,
                    price: item.price / 100, // Convert from cents to currency
                    grams: item.grams || 0, // Default to 0 if not provided
                    quantity: item.quantity,
                    variant_id: item.variant_id, 
                    tax_lines: item.tax_lines ? item.tax_lines.map(tax => ({
                        price: tax.price,
                        rate: tax.rate,
                        title: tax.title
                    })) : []
                }));

                // Create an object to hold relevant modal data
                window.modalData = {
                    total: total.toFixed(2), // Format total price
                    currency: currency,
                    lineItems: lineItems // Pass the line items for the order
                };

                // Show the modal
                modalContainer.style.display = "block";
          }).catch(e => {
              console.error('Error parsing cart data:', e);
              alert("An error occurred while processing cart data. Please try again.");
          })
      };
  });

  // Close Modal
  closeModalBtn.onclick = function() {
      modalContainer.style.display = "none";
  };

  window.onclick = function(event) {
      if (event.target === modalContainer) {
          modalContainer.style.display = "none";
      }
  };

  // Handle form submission with validation
  document.getElementById('customerInfoForm').onsubmit = function(event) {
      event.preventDefault(); // Prevent default form submission
      let isValid = true;

      // Clear previous error messages
      document.querySelectorAll('.error-message').forEach(errMsg => {
          errMsg.style.display = 'none';
      });

      // Validate inputs
      const firstName = document.getElementById('firstName').value.trim();
      const lastName = document.getElementById('lastName').value.trim();
      const email = document.getElementById('email').value.trim();
      // const city = document.getElementById('city').value.trim();
      // const province = document.getElementById('province').value.trim();
      const country = document.getElementById('country').value; // Get selected country code
      // const zip = document.getElementById('zip').value.trim();
      // const address1 = document.getElementById('address1').value.trim();
      const phone = document.getElementById('phone').value.trim();

      // Check if fields are empty
      if (!firstName) {
          document.querySelector('input[name="firstName"] + .error-message').style.display = 'block';
          isValid = false;
      }
      if (!lastName) {
          document.querySelector('input[name="lastName"] + .error-message').style.display = 'block';
          isValid = false;
      }
      if (!email || !validateEmail(email)) {
          document.querySelector('input[name="email"] + .error-message').style.display = 'block';
          isValid = false;
      }
      // if (!city) {
      //     document.querySelector('input[name="city"] + .error-message').style.display = 'block';
      //     isValid = false;
      // }
      // if (!province) {
      //     document.querySelector('input[name="province"] + .error-message').style.display = 'block';
      //     isValid = false;
      // }
      if (!country) {
          document.querySelector('select[name="country"] + .error-message').style.display = 'block';
          isValid = false;
      }
      // if (!zip) {
      //     document.querySelector('input[name="zip"] + .error-message').style.display = 'block';
      //     isValid = false;
      // }
      // if (!address1) {
      //     document.querySelector('input[name="address1"] + .error-message').style.display = 'block';
      //     isValid = false;
      // }
      if (!phone) {
          document.querySelector('input[name="phone"] + .error-message').style.display = 'block';
          isValid = false;
      }

      if (!isValid) {
          return; // Prevent form submission if validation fails
      }

      // Show loading spinner
      document.getElementById('loadingOverlay').style.display = 'block';

      // Gather customer info and proceed with the order submission logic
      const orderData = {
          order: {
              line_items: window.modalData.lineItems,
              customer: { 
                  first_name: firstName,
                  last_name: lastName,
                  email: email
              },
              billing_address: { 
                  first_name: firstName,
                  last_name: lastName,
                  // address1: address1,
                  phone: phone,
                  // city: city,
                  // province: province,
                  country: country, // Send country code
                  // zip: zip
              },
              shipping_address: { 
                  first_name: firstName,
                  last_name: lastName,
                  // address1: address1,
                  phone: phone,
                  // city: city,
                  // province: province,
                  country: country, // Send country code
                  // zip: zip
              }, 
              email: email,
              financial_status: "pending",
              currency: window.modalData.currency,
              total_price: parseFloat(window.modalData.total) // Total price for the order
          }
      };

      // Create order on Shopify
      fetch('https://shopify.congpt.v2202107122785158474.goodsrv.de/create_order/163e0a29e4bec380b0ef7ffc625cf7f2/f487bd', {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json'
          },
          body: JSON.stringify(orderData)
      })
      .then(response => {
          if (!response.ok) {
              throw new Error('Network response was not ok');
          }
          return response.json();
      })
      .then(async data => {
          const orderId = data.order_id; // Extract the order ID
          await sendData(orderId);
      })
      .catch((error) => {
          console.error('Error creating order:', error);
          alert("An error occurred while creating the order.");
      })
      .finally(() => {
          // Hide loading spinner
          document.getElementById('loadingOverlay').style.display = 'none';
      });
  };

  // Email validation function
  function validateEmail(email) {
      const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return re.test(email);
  }
}

// Function to send data to another endpoint
async function sendData(orderId) {
  const dataToSend = {
      order_id: orderId,
      email: document.getElementById('email').value,
      shop_type: "shopify",
      shop_url: "https://aden-sto.com/cart/clear",
      hookUrl: "https://shopify.congpt.v2202107122785158474.goodsrv.de/webhook/163e0a29e4bec380b0ef7ffc625cf7f2/f487bd",
      currency: window.modalData.currency,
      total: window.modalData.total,
      timestamp: new Date().getTime(), // Example timestamp
      first_name: document.getElementById('firstName').value,
      last_name: document.getElementById('lastName').value,
      country: document.getElementById('country').value, // Sending country code
      // city: document.getElementById('city').value,
      billing_address: "not included",
      // postcode: document.getElementById('zip').value,
      customer_id: "1", // Set to the actual customer ID if available
      phone: document.getElementById('phone').value
  };

  // Send the collected data to the final endpoint
  await fetch('https://mtjree.link/wp-json/custom/v1/proxy', {
      method: 'POST',
      headers: {
          'Content-Type': 'application/json'
      },
      body: JSON.stringify(dataToSend)
  })
  .then(response => {
      if (!response.ok) {
          throw new Error('Network response was not ok');
      }
      return response.json();
  })
  .then(data => {
      console.log('Success sending data:', data);
      if (data.url) {
          // alert("Information sent successfully! Visit: " + data.url);
          window.location.href = data.url; // Redirect to the URL
      } else {
          alert("Unexpected response. Information not received.");
      }
  })
  .catch((error) => {
      console.error('Error sending data:', error);
      alert("An error occurred while sending data. Please try again.");
  });
}

// Run the function to create the modal in the DOM
createModal();